// German

const lang = {
  gateMediaPreviewHeader: 'Könnte dir auch gefallen',
  loadmore: 'Mehr anzeigen',
  nextMedia: 'Nächstes Medien',
  previousMedia: 'Vorherige Medien',
  closePost: 'Beitrag schließen',
  nextPost: 'Nächster Beitrag',
  previousPost: 'Vorherig Beitrag',
  outOfStock: 'Ausverkauft',
  numberOfReviews(n) {
    return n === 1 ? 'Rezension' : 'Rezensionen'
  },
  reportFormField: 'Bitte geben Sie eine Nachricht ein',
  reportPost: 'Beitrag Melden',
  reportFormTitle: 'Möchten Sie dieses Bild melden?',
  reportFormDetails:
    'Wenn Sie der Meinung sind, dass das Bild unangemessen oder illegal ist oder die Rechte einer Person verletzt, können Sie den Inhalt melden. Wenn Sie das Bild / den Text melden, werden die Moderatoren benachrichtigt und die entsprechenden Massnahmen ergriffen.',
  reportFormMessagePlaceholder: 'Geben Sie den Grund Ihres Berichts an',
  reportFormMessageLabel: 'Nachricht',
  reportFormEmailLabel: 'Ihre Email',
  reportFormSubmitButtonText: 'Nachricht senden',
  reportFormCancelButtonText: 'Abbrechen',
  reportFormSentTitle: 'Vielen Dank für Ihre Nachricht!',
  reportFormSentCloseButtonText: 'Schließen',
  cardAndTileAriaLabel:
    'Unten sehen Sie eine Liste mit Beiträgen von Konten in diversen sozialen Medien',
  carouselAriaLabel:
    'Nachstehend befindet sich eine Auswahl mit Beiträgen von Konten in diversen sozialen Medien',
  singleAriaLabel: 'Unten finden Sie einen Beitrag von einem Social-Media-Konto',
  poweredBy: 'Betrieben von Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` veröffentlicht am ${date}` : ''
    const createdByString = userName ? ` von ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Laden Sie Ihre Medien hoch',
  openTheGate: 'Öffnen Sie den Dialog',
}

export default lang
